export default __webpack_public_path__ + "7ee14c637e39445d709322f111f847d4.woff";